import * as React from 'react';
import { Cookies, withCookies } from 'react-cookie';

const CookiesContext = React.createContext<Cookies | undefined>(undefined);

type CookiesProviderProps = React.PropsWithChildren<{ cookies: Cookies | undefined }>;

const CookiesProvider = withCookies(({ cookies, children }: CookiesProviderProps) => (
    <CookiesContext.Provider value={cookies}>{children}</CookiesContext.Provider>
));

CookiesContext.displayName = 'CookiesContext';

const useCookiesContext = () => React.useContext(CookiesContext);

export { CookiesProvider, useCookiesContext };
